import { EmptyState } from '@common/components/EmptyState';

export default function AccessSessionGroupListNoSearchResults() {
  return (
    <EmptyState
      title="No results found"
      imgSrc="/static/illustrations/not-found.svg"
      body="Try different keywords or remove search filters"
    />
  );
}
